import React, {Component} from "react"

import Footer from "components/Footer/Footer"
import Header from "components/Header/Header"

import {observer} from "mobx-react"

@observer
class AppLayout extends Component {
  constructor(props) {
    super( props )
  }

  componentWillMount() {
    const { location } = this.props
  }

  render() {
    const { children, location } = this.props

    return (
      <div className="flex flex-column min-vh-100">
        <Header location={location} />
        {/*<Profiles/>*/}
        <div className="flex-auto">{children}</div>
        <Footer/>
      </div>
    )
  }
}
export default AppLayout



// WEBPACK FOOTER //
// ./src/theme/base/layout/AppLayout.js